export default __webpack_public_path__ + "static/media/img-0814-czech-republic-half-face.cf79a1b4.png";